import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { NUMBER_DAY_MAP } from "../common/mappings";
import { Divider, Space, TimePicker, Button } from "antd";
import { SlotSelector } from "./SlotSelector";
import { AddSlot } from "./AddSlot";

const SingleDayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
`;
const DaySlots = styled.div`
  border: 1px solid #ddd;
  color: #999;
  padding: 10px 15px;
  display: ${(props) => (props.show ? "block" : "none")};
`;
const SingleDay = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  //   border: 1px solid #144fc3;
  border: 1px solid #ddd;
  padding: 10px 15px;
  //   border-radius: 10px;
  //   color: #144fc3;
  color: #999;
  cursor: pointer;
`;
const DaysSlots = (props) => {
  const { numericDay } = props;
  const [data, setData] = useState(props.data[props.numericDay]);
  const [isEditAdd, setIsEditAdd] = useState(false);
  // const onChange = (time, timeString) => {
  //   console.log(time, timeString);
  // };
  useEffect(() => {
    console.log("Time to update the parent");
    props.changeHandler(data);
  }, [data]);
  return (
    <SingleDayWrapper>
      <SingleDay onClick={() => setIsEditAdd(!isEditAdd)}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {NUMBER_DAY_MAP[numericDay]}
          <div>{`(${data.length} slots)`}</div>
        </div>

        <div>{data.length == 0 ? "Add" : "Edit"}</div>
      </SingleDay>
      <DaySlots show={isEditAdd}>
        <AddSlot
          addHandler={(slot, slotString) => {
            let newData = JSON.parse(JSON.stringify(data));
            newData.push(slotString);
            setData(newData);
          }}
        />
        <Divider />
        <Space>
          {data.length > 0
            ? data.map((slot, slotI) => {
                return (
                  <SlotSelector
                    selected={true}
                    slot={slot}
                    deleteHandler={() => {
                      let newData = JSON.parse(JSON.stringify(data));
                      newData.splice(slotI, 1);
                      setData(newData);
                    }}
                    changeHandler={(time, timeString) => {
                      let newData = JSON.parse(JSON.stringify(data));
                      newData[slotI] = {
                        s: timeString[0],
                        e: timeString[1],
                      };
                      setData(newData);
                    }}
                  />
                );
              })
            : "You are not working this day of the week"}
        </Space>
      </DaySlots>
    </SingleDayWrapper>
  );
};

DaysSlots.propTypes = {};

export { DaysSlots };
